import { environment } from 'environments/environment';

const MODULE_LABELS: Record<string, string> = {
    vente: 'Vente',
    achat: 'Achat',
    gestion_stock: 'Gestion stock',
    'gestion-stock': 'Gestion stock',
};

export function getErpModuleDisplayLabel(): string {
    const id = String((environment as { currentModule?: string }).currentModule ?? '').trim();
    if (!id) {
        return 'ERP';
    }
    return MODULE_LABELS[id] ?? MODULE_LABELS[id.replace(/-/g, '_')] ?? id;
}

export function buildErpPageHeading(sectionTitle?: string | null): string {
    const module = getErpModuleDisplayLabel();
    const section = String(sectionTitle ?? '').trim();
    if (!section) {
        return module;
    }
    if (section.startsWith(`${module} · `)) {
        return section;
    }
    return `${module} · ${section}`;
}

export function stripErpModulePrefixFromHeading(fullTitle: string): string {
    const module = getErpModuleDisplayLabel();
    const t = String(fullTitle ?? '').trim();
    const prefix = `${module} · `;
    if (t.startsWith(prefix)) {
        return t.slice(prefix.length).trim();
    }
    return t;
}
